import React, { useEffect, useRef } from "react";
import styled from "styled-components";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  color?: string;
  backgroundColor?: string;
  onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) &
    (() => any);
}

export const SubmitButton = ({
  text,
  color,
  backgroundColor,
  onClick,
  ...props
}: IProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && buttonRef.current) {
        buttonRef.current.click();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <ButtonContainer
      ref={buttonRef}
      type="submit"
      color={color || "#FFF"}
      backgroundColor={backgroundColor || "#01A8CE"}
      onClick={onClick}
      {...props}
    >
      {text}
    </ButtonContainer>
  );
};

const ButtonContainer = styled.button<Omit<IProps, "text">>`
  border-radius: 0.5em;
  padding: 1em 1em 1em 1em;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  font-size: 12px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
  }

  &:hover {
    background-color: #01A8CE;
    color: #fff;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;
